export const RESEND_OTP_ACTION_LOADING = 'RESEND_OTP_ACTION_LOADING';
export const RESEND_OTP_ACTION_SUCCESS = 'RESEND_OTP_ACTION_SUCCESS';
export const RESEND_OTP_ACTION_FAILURE = 'RESEND_OTP_ACTION_FAILURE';
export const RESET_RESEND_OTP_ACTION = 'RESET_RESEND_OTP_ACTION';

// URLs
export const RESEND_OTP_URL = '/otp/resend';
